import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ConfirmationService, SelectItem, MessageService } from 'primeng/api';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { SpecialityService } from 'src/app/services/speciality.service';
import { Specialty_data, CrudSpeciality, DepartmentSpecialty } from 'src/app/models/Speciality';
import { Table } from 'primeng/table';
import { Title } from "@angular/platform-browser";
import { PromiseResult, ErrorModel, ServerError } from '../../../../models/PromiseResult';
import { HttpErrorResponse } from '@angular/common/http';
import { name_input, address, city, phoneNumber, zipCode, textareaBox, dose_input, number_input, DOCUMENT_SUPPORTED_TYPES, IMAGE_PROFILE_ID_SUPPORTED_TYPES, RESUME_SUPPORTED_TYPES } from 'src/app/constant/constant';
import { TraceClassDecorator } from '@sentry/angular';
import { CountriesService } from 'src/app/services/countries.service';
import { Form_Data } from 'src/app/models/util.models';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@TraceClassDecorator()
@Component({
    selector: 'app-departments',
    templateUrl: './departments.component.html',
    styleUrls: ['./departments.component.css'
        , '../../../../../assets/css/custom-egd.css'
    ],
    encapsulation: ViewEncapsulation.None,
    providers: [
        ConfirmationService,
        MessageService
    ]

})
export class DepartmentsComponent implements OnInit {
    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    loading = false;
    is_primary_provider: boolean = false;
    status: SelectItem[];
    countries: SelectItem[] = [];
    selectedCountries: string[] = [];
    // [x: string]: any;
    specialty_data: Specialty_data = new Specialty_data();
    crudSpeciality: CrudSpeciality = new CrudSpeciality();

    file = null;
    provider_id: string = "";
    uploadFile: File;

    createDialog: boolean = false;

    updateDialog: boolean = false;

    selectedDepartmentSpeciality: DepartmentSpecialty;

    newDepartment: boolean;

    department: DepartmentSpecialty = new DepartmentSpecialty();

    optionChanged = false;
    isShow = true;
    SelectedOption = '1';
    confirmDialogVisible = false;
    departments: DepartmentSpecialty[] = [];
    // departments:AllSpeciality[]=[];
    editID: number = -1;
    featured: SelectItem[];
    selectedFeatured = null;
    selectedStatus = null;
    featuredField = false;
    // specialityForm={
    //   name:"",
    //   is_selected:"",
    //   is_featured:"",
    //   speciality_url:"",
    //   file:null,
    // };

    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;

    table_response: PromiseResult;
    table_error: ErrorModel;
    table_serverError: ServerError;
    table_posting: boolean;

    image_types: string[] = IMAGE_PROFILE_ID_SUPPORTED_TYPES;
    resume_types: string[] = RESUME_SUPPORTED_TYPES;
    document_types: string[] = DOCUMENT_SUPPORTED_TYPES;
    slug: string = "";


    @ViewChild('dt1') dt1: Table;

    constructor(
        private readonly confirmation: ConfirmationService,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly specialtyservice: SpecialityService,
        private readonly titleServices: Title,
        private readonly messageService: MessageService,
        private readonly countryService: CountriesService,
        private readonly providerStateService: ProviderStateService
    ) {

    }
    async ngOnInit() {
        this.titleServices.setTitle("Dashboard - Departments");
        this.is_primary_provider = this.providerStateService.getIsPrimaryProvider();
        this.provider_id = this.providerStateService.getProviderId();
        this.slug = this.providerStateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Departments' }
        ]);
        this.ResetResultModels();
        this.ResetResultTableModels();
        this.loading = true;
        await this.getDepartments();
        await this.GetCountries();
        this.loading = false;
        this.status = [
            { label: 'Active', value: true },
            { label: 'Inactive', value: false }
        ];
        this.featured = [
            { label: 'Yes', value: true },
            { label: 'No', value: false }
        ];
    }


    private ResetResultModels(): void {

        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        }
    }

    private ResetResultTableModels(): void {

        this.table_response = {
            success: null,
            error: null,
            data: null
        };
        this.table_serverError = {
            statusCode: null,
            error: null,
            message: null
        }
    }

    showDialogToAdd() {
        this.newDepartment = true;
        this.department = new DepartmentSpecialty();
        this.ResetResultModels();
        this.createDialog = true;
        this.selectedCountries = [];
    }

    async GetCountries() {
        await this.countryService
            .getCountries(this.provider_id)
            .toPromise()
            .then((result) => {
                this.countries = [];
                const temp: SelectItem[] = [];
                for (const country of result)
                    temp.push({
                        label: country.country_name,
                        value: country.id
                    });
                this.countries = temp;
                this.selectedCountries = [];
            });
    }


    async save() {
        this.ResetResultModels();
        this.posting = true;
        //using dummy specialy id
        if (!this.specialty_data.api_data.featured_id) {
            this.specialty_data.api_data.featured_id = false;
        }
        else {
            this.specialty_data.api_data.featured_id = this.department.featured_id;
        }
        this.specialty_data.api_data.is_supported = this.department.is_supported;
        this.specialty_data.api_data.specialty_name = this.department.specialty_name;
        this.specialty_data.api_data.file = this.file;
        this.specialty_data.api_data.countryIds = this.selectedCountries;
        this.specialty_data.form_data = new Form_Data();
        this.specialty_data.form_data.form_data = this.specialty_data.form_data.create_form_data(this.specialty_data.api_data, new FormData(), "");
        await this.specialtyservice.CreateNewSpeciality(this.specialty_data.form_data.form_data).toPromise().then(async result => {
            this.response = result;
            if (this.response.success) {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Speciality Added Successfully",
                });
                this.createDialog = false;
                this.posting = false;
                this.resetForm();
            }
            else if (!this.response.success) {
                this.posting = false;
                this.error = result.error;
            }
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });
        await this.getDepartments();
        // await this.resetForm();
    }

    async update() {
        this.ResetResultModels();
        this.posting = true;
        //using dummy specialy id
        if (!this.specialty_data.api_data.featured_id) {
            this.specialty_data.api_data.featured_id = false;
        }
        else {
            this.specialty_data.api_data.featured_id = this.department.featured_id;
        }
        this.specialty_data.api_data.is_supported = this.department.is_supported;
        this.specialty_data.api_data.specialty_name = this.department.specialty_name;
        this.specialty_data.api_data.file = this.file;
        this.specialty_data.api_data.countryIds = this.selectedCountries;
        this.specialty_data.form_data = new Form_Data();
        this.specialty_data.form_data.form_data = this.specialty_data.form_data.create_form_data(this.specialty_data.api_data, new FormData(), "");
        await this.specialtyservice.UpdateSpeciality(this.department.id, this.specialty_data.form_data.form_data).toPromise().then(async result => {

            this.response = result;
            if (this.response.success) {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Speciality Updated Successfully",
                });
                this.resetForm();
                this.resetEditID()
                this.updateDialog = false;
                this.posting = false;
            }
            else if (!this.response.success) {
                this.posting = false;
                this.error = result.error;
            }
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });
        // this.departments.push({
        //   id:this.departments.length+1,
        //   specialty_name:this.department.specialty_name,
        //   specialty_id:this.departments.length+1,
        //   is_supported:this.department.is_supported,
        //   featured_id:this.department.featured_id,
        //   speciality_url:""});
        await this.getDepartments();


    }

    resetForm() {
        this.department = {
            id: -1,
            specialty_name: "",
            serial: -1,
            is_supported: null,
            featured_id: null,
            speciality_url: "",
            countryIds: []

        }
        this.ResetResultModels();
        this.crudSpeciality = new CrudSpeciality();
        this.selectedFeatured = null;
        this.selectedStatus = null;
        this.featuredField = false;
        this.file = null;
        // this.editID=-1;
    }

    resetEditID() {
        this.editID = -1;
    }


    Cancel() {
        this.resetForm();
        this.createDialog = false;
        this.updateDialog = false;
        this.editID = -1;
    }

    async confirmDelete(event: Event, department) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmation.confirm({
            key: 'confirm-delete-speciality',
            message: 'Are you sure to delete the speciality ' + department.specialty_name + '?',
            accept: () => { this.deleteItem(department); },
        });
    }
    ToggleOption(event, id) {
        this.editID = id;
        this.optionChanged = true;
        //this.editID=-1;

        this.departments[id].is_supported = event;

    }

    last_status: boolean = null;
    edit(edit_department: DepartmentSpecialty) {
        this.ResetResultModels()
        // for (let i = 0; i < this.departments.length; i++) {
        //     if (this.departments[i].id == edit_id)
        //         this.editID = i;
        // }
        // // this.isShow=false;
        // this.resetForm();
        // // this.editID=edit_id;

        // this.department = {
        //     id: this.departments[this.editID].id,
        //     specialty_name: this.departments[this.editID].specialty_name,
        //     specialty_id: this.departments[this.editID].specialty_id,
        //     is_supported: this.departments[this.editID].is_supported,
        //     featured_id: this.departments[this.editID].featured_id,
        //     speciality_url: this.departments[this.editID].speciality_url,
        // }
        this.department = {
            id: edit_department.id,
            specialty_name: edit_department.specialty_name,
            serial: edit_department.serial,
            is_supported: edit_department.is_supported,
            featured_id: edit_department.featured_id,
            speciality_url: edit_department.speciality_url,
            countryIds: edit_department.countryIds
        }
        if (this.department.is_supported) {
            this.selectedStatus = "Yes"
            this.featuredField = true;
            if (this.department.featured_id) {
                this.selectedFeatured = "Yes";
            }
            else if (!this.department.featured_id) {
                this.selectedFeatured = "No";
            }
        }
        else if (!this.department.is_supported) {
            this.selectedStatus = "No"
            this.featuredField = false;
            this.selectedFeatured = "No";

        }
        this.selectedCountries = this.department.countryIds;
        this.updateDialog = true;



    }

    // savechanges(id:number){
    //   this.AgainDisabled(id);
    //   this.editID=-1;
    // }
    Active(even: Event, id: number) {
        this.departments[id].is_supported = true;


    }
    Inactive(even: Event, id: number) {

        this.departments[id].is_supported = false;
    }
    async getDepartments() {
        this.ResetResultTableModels();
        this.loading = true;
        await this.specialtyservice.GetAllSpecialities(undefined, this.provider_id).toPromise().then(result => {
            this.table_response = result;
            if (this.table_response.success) {
                let temp: DepartmentSpecialty[] = []

                for (let i = 0; i < result.data.length; i++) {
                    let countryIds = result.data[i].d_speciality_country.map((countryObj: any) => countryObj.country_id);
                    temp.push({
                        serial: i + 1,
                        specialty_name: result.data[i].specialty_name,
                        id: result.data[i].id,
                        is_supported: result.data[i].is_supported,
                        featured_id: result.data[i].featured_id,
                        speciality_url: result.data[i].specialty_url,
                        countryIds: countryIds
                    });
                }

                this.departments = temp;
                this.loading = false;
            }
            else if (!this.table_response.success) {
                this.loading = false;
            }
        }).catch((error: HttpErrorResponse) => {
            this.table_serverError = error.error;
            this.table_response.success = false;
            this.loading = false;
        });


    }

    onSelectStatus() {

        if (this.selectedStatus == "Yes") {
            this.featuredField = true;
            this.department.is_supported = true;
            this.selectedFeatured = null;
        }
        if (this.selectedStatus == "No") {
            this.featuredField = false;
            this.department.is_supported = false;
            this.selectedFeatured = "No";
            this.department.featured_id = false;

        }
    }

    onSelectFeatured() {

        if (this.selectedFeatured == "Yes") {
            this.department.featured_id = true;
        }
        if (this.selectedFeatured == "No") {
            this.department.featured_id = false;
        }
    }

    uploadFiles(file: File[]) {
        if (this.image_types.includes(file[0].type.toLowerCase())) {
            if (file[0].size > 5033165) {
                // this.fileu=true;
                this.file = null;
            }
            else if (file[0].size < 5033165) {
                // this.fileu=false;
                this.file = file[0];
            }
        }
        else this.file = null;
    }

    clearfile() {
        this.file = null;
    }



    async deleteItem(delete_department: DepartmentSpecialty) {
        this.resetForm();
        await this.specialtyservice.DeleteSpeciality(delete_department.id).toPromise().then(async result => {

            this.response = result;
            if (this.response.success) {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Speciality Deleted Successfully",
                });
            }
            else if (!this.response.success) {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    sticky: true,
                    detail: result.error.code + " : " + result.error.message,
                });
                this.posting = false;
                this.error = result.error;
            }
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });
        await this.getDepartments();
        this.resetForm();
        this.resetEditID();
    }

    resetSort() {
        this.loading = true;
        this.dt1.sortOrder = 0;
        this.dt1.sortField = '';
        this.dt1.reset();
        this.loading = false;
    }

}
